import { render, staticRenderFns } from "./ModalConfirmarTelefono.vue?vue&type=template&id=0d6bcdaf&scoped=true"
import script from "./ModalConfirmarTelefono.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarTelefono.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarTelefono.vue?vue&type=style&index=0&id=0d6bcdaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6bcdaf",
  null
  
)

export default component.exports